/* eslint-disable no-restricted-imports */
import { Menu as OgMenu, MenuProps as OgMenuProps } from '@mui/material';
import { sxAppend } from '../../sx';

const styleFixMenuBackground = {
    '& ul[role="menu"]': {
        backgroundColor: 'background.paper',
    },
};

export type MenuProps = OgMenuProps & {
    withCurvedCorners?: boolean;
};

export function Menu({ sx, ...props }: MenuProps) {
    return <OgMenu sx={sxAppend(styleFixMenuBackground, sx)} {...props} />;
}
